import React from 'react';

import IconFemtasy from 'components/IconFemtasy';
import Message from 'components/Message';
import Typography from 'components/Typography';

const CourseTotalDuration = ({
  totalCourseLength,
  numberOfAudios,
}: {
  totalCourseLength: string;
  numberOfAudios: number;
}) => {
  return (
    <div className="CourseHeader__totalDuration">
      <Typography className="CourseHeader__totalDuration__items" variant="body">
        <IconFemtasy icon="Clockline" size="16" />
        <Message message={totalCourseLength} />
      </Typography>
      <Typography className="CourseHeader__totalDuration__items" variant="body">
        <IconFemtasy icon="Seriesline" size="16" />
        <Message
          message={{
            id: 'components.JourneyDetailsHeader.seriesLength',
            values: { total: numberOfAudios },
          }}
        />
      </Typography>
    </div>
  );
};

export default CourseTotalDuration;
